// Schedule Option Util
import _ from 'lodash'

import app from '../app.jsx'
import DateUtil from './dateutil.jsx'

const async = require('async')

class ScheduleOptionUtil {
  getUserScheduleOptions (userId, callback) {
    const params = {
      query: {
        userId: userId,
        $sort: { fromDate: -1 }
      }
    }

    app
      .service('/api/user/scheduleoption')
      .find(params)
      .then(result => {
        callback(null, result.data)
      })
      .catch(err => {
        callback(err)
      })
  }

  updateUserScheduleOption (
    userId,
    schedules,
    scheduleOption,
    userTimezone,
    callback
  ) {
    let timezoneOffset = 0
    const userSchedules = schedules.map((schedule, idx) => {
      const schedObj = {
        dayNo: idx + 1,
        timeTaken: schedule.timeTaken
      }

      return schedObj
    })

    let timezoneInfo = null
    if (userTimezone) {
      timezoneInfo = DateUtil.getTimezoneInfo(userTimezone)
    }

    if (timezoneInfo) {
      timezoneOffset = -1 * timezoneInfo.offset * 60
    }

    if (scheduleOption.id.indexOf('schedule-') === 0) {
      delete scheduleOption.id
    }

    if (!scheduleOption || !scheduleOption.id) {
      const createObj = {
        userId: userId,
        teamId: app.getTeamId(),
        schedules: userSchedules,
        fromDate: scheduleOption ? scheduleOption.fromDate : null,
        toDate: scheduleOption ? scheduleOption.toDate : null,
        timezoneOffset: timezoneOffset || new Date().getTimezoneOffset()
      }

      app
        .service('/api/user/scheduleoption')
        .create(createObj, {})
        .then(schdOptRes => {
          if (scheduleOption) {
            scheduleOption.id = schdOptRes.id
          }

          callback(null)
        })
        .catch(err => {
          callback(err)
        })
    } else {
      const updateObj = {
        schedules: userSchedules,
        fromDate: scheduleOption.fromDate,
        toDate: scheduleOption.toDate,
        timezoneOffset: new Date().getTimezoneOffset()
      }

      app
        .service('/api/user/scheduleoption')
        .patch(scheduleOption.id, updateObj, {})
        .then(_schdOptRes => {
          callback(null)
        })
        .catch(err => {
          callback(err)
        })
    }
  }

  updateUserScheduleOptions (
    userId,
    schedules,
    scheduleOptions,
    userTimezone,
    callback
  ) {
    async.map(
      scheduleOptions,
      (scheduleOption, mapDone) => {
        return this.updateUserScheduleOption(
          userId,
          scheduleOption.schedules,
          scheduleOption,
          userTimezone,
          mapDone
        )
      },
      asyncErr => {
        if (asyncErr) {
          callback(asyncErr)
        } else {
          callback(null)
        }
      }
    )
  }

  getDefaultScheduleOption () {
    return {
      schedules: this._getDefaultSchedules(),
      fromDate: null,
      toDate: null
    }
  }

  getAllSchedulePeriods (scheduleOptions, excludeSchduleId) {
    const periods = []
    scheduleOptions.forEach(opt => {
      if (!excludeSchduleId || opt.id !== excludeSchduleId) {
        periods.push({
          from: opt.fromDate,
          to: opt.toDate
        })
      }
    })

    return periods
  }

  getRenderScheduleObject (scheduleOption) {
    const schedule = _.cloneDeep(scheduleOption)
    const defaultSchedule = this.getDefaultScheduleOption()

    schedule.schedules = defaultSchedule.schedules || []
    schedule.schedules.map(dayItem => {
      const existingDayItem = _.find(
        scheduleOption.schedules,
        obj => obj.dayNo === dayItem.dayNo
      )

      dayItem.timeAvailable = existingDayItem ? existingDayItem.timeTaken : 0
    })

    return schedule
  }

  createSchedule (createData, callback) {
    let timezoneOffset = 0
    const userTeam = app.loggedInUserTeam
    let timezoneInfo = null

    if (userTeam.timezone) {
      timezoneInfo = DateUtil.getTimezoneInfo(userTeam.timezone)
    }

    if (timezoneInfo) {
      timezoneOffset = -1 * timezoneInfo.offset * 60
    }

    createData.userId = app.loggedInId
    createData.teamId = app.getTeamId()
    createData.timezoneOffset = timezoneOffset || new Date().getTimezoneOffset()

    app
      .service('/api/user/scheduleoption')
      .create(createData)
      .then(_res => {
        callback(null)
      })
      .catch(err => {
        callback(err)
      })
  }

  updateSchedule (scheduleId, updateData, callback) {
    if (scheduleId) {
      app
        .service('/api/user/scheduleoption')
        .patch(scheduleId, updateData)
        .then(_schdOptRes => {
          callback(null)
        })
        .catch(err => {
          app.debug('PageSchedule: _onEditSchedule Error', err)
          callback(err)
        })
    } else {
      callback(null)
    }
  }

  removeSchedule (scheduleId, callback) {
    if (scheduleId) {
      app
        .service('/api/user/scheduleoption')
        .remove(scheduleId)
        .then(_deleteRes => {
          callback(null)
        })
        .catch(deleteErr => {
          callback(deleteErr)
        })
    } else {
      callback(null)
    }
  }

  removeUserScheduleOptions (scheduleIds, callback) {
    if (scheduleIds && scheduleIds.length > 0) {
      app
        .service('/api/user/scheduleoption')
        .remove(null, { query: { _id: scheduleIds } })
        .then(_deleteRes => {
          callback(null)
        })
        .catch(deleteErr => {
          callback(deleteErr)
        })
    } else {
      callback(null)
    }
  }

  _getDefaultSchedules () {
    const days = []

    for (let day = 1; day < 15; day++) {
      const bWeekEnd = this._isWeekEnd(day)
      const dayObj = {
        dayNo: day,
        title: this._getDayTitle(day),
        isWeekEnd: bWeekEnd,
        timeAvailable: (bWeekEnd ? 0 : 8) * 60
      }

      days.push(dayObj)
    }

    return days
  }

  _isWeekEnd (day) {
    return day === 6 || day === 7 || day === 13 || day === 14
  }

  _getDayTitle (dayNo) {
    const day = dayNo > 7 ? dayNo - 7 : dayNo
    return DateUtil.getDisplayDayTitle(day)
  }
}

export default new ScheduleOptionUtil()
